import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TablistContextProvider } from './TablistContext-Bpw2P1bl.js';
import { N as Nav } from './Nav-Dsk9TOvt.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40019350__sc-jj0i00-0"
})(["position:relative;", ""], isMobile(css(["::after{position:absolute;height:100%;width:", ";left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;top:0;content:\" \";background:", ";}/*! @noflip */ [dir=\"rtl\"] &&::after{background:", ";right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"], ({
  theme
}) => theme.tabbedNavigation.scrollIndicatorWidth, ({
  theme
}) => theme.tabbedNavigation.scrollIndicatorRight, ({
  theme
}) => theme.tabbedNavigation.scrollIndicatorLeft)));
const TabbedNavigation = ({
  children,
  size = 'base',
  tablist = false,
  taktId,
  taktValue
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('tabbed-navigation')
}, /*#__PURE__*/React__default.createElement(TablistContextProvider, {
  isTablist: tablist !== null && tablist !== void 0 ? tablist : false,
  size: size
}, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(Nav, null, children))));

export { TabbedNavigation as T };
//# sourceMappingURL=TabbedNavigation-D2hXL45Z.js.map
